import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router, { installRoutes } from './router'
import vuetify from './plugins/vuetify'
import * as LocalStorageService from '@/services/LocalStorageService'
import * as Language from '@/services/Language'
import { i18n } from './i18n/settings'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)

// Load from local storage (token, settings...)
LocalStorageService.loadState()

// The language of the app: the one its address carries, or the visitor's own when the address carries
// none (it is moved there right away: see settleAddress in router/index.js).
const language = Language.start()

// The routes of that language: the app boots on the language of the address as it arrived.
installRoutes(language)

app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')
